import { render, staticRenderFns } from "./MedicineShow.vue?vue&type=template&id=0a1c9ddd&scoped=true&"
import script from "./MedicineShow.vue?vue&type=script&lang=js&"
export * from "./MedicineShow.vue?vue&type=script&lang=js&"
import style0 from "./MedicineShow.vue?vue&type=style&index=0&id=0a1c9ddd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1c9ddd",
  null
  
)

export default component.exports